export default "__VITE_ASSET__CRK77wog__"